import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TagsService } from "../../../services/tags.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Navigation } from "../../../model/navigation";
import { Messages } from "../../../model/messages";
import { Tag } from "../../../model/tags";
@Component({
  selector: "tags",
  templateUrl: "./tags.component.html",
  styleUrls: ["./tags.component.css"],
})
export class TagsComponent implements OnInit {
  @Output() tagSelected = new EventEmitter<number>();
  @Output() createNewTag = new EventEmitter<void>();
  @Input() isMobile: boolean = false;

  tags: BehaviorSubject<Tag[]>;
  messages: BehaviorSubject<Messages>;
  selectedTags: Tag | null = null;
  filteredTags: BehaviorSubject<Tag[]> = new BehaviorSubject<Tag[]>([]);
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
  tagCount: number = 0;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  constructor(
    private tagsService: TagsService,
    private authService: AuthService,
    private router: Router
  ) {
    this.messages = new BehaviorSubject(Messages.EMPTY);
    this.tags = new BehaviorSubject<Tag[]>([]);
  }

  ngOnInit(): void {
    this.title.next("tags.title");
    const token = this.authService.token;

    this.tagsService.tags(token).subscribe({
      next: (messages) => {
        if (messages.hasAnyMessages) {
          this.messages.next(messages);
        }
      },
      complete: () => {},
    });

    this.tagsService.tagsObservable.subscribe((data) => {
      const sortedTags = data.sort((a:Tag, b:Tag) => a.value.localeCompare(b.value));

      this.tags.next(sortedTags);
      this.filteredTags.next(sortedTags);
      this.tagCount = sortedTags.length;
    });
  }
  searchTags(): void {
    const query = this.searchTerm.getValue().toLowerCase();

    const filtered = query
      ? this.tags.value.filter((tag) =>
          tag.value.toLowerCase().includes(query)
        )
      : this.tags.value;

    this.filteredTags.next(filtered);
  }

  select(tags: Tag) {
    this.tagsService.select(tags);

    if (tags && tags.id) {
      this.router.navigate([`tags/${tags.id}`]).then(() => {
        this.tagSelected.emit(tags.id!!);
      });
    }
  }

  createTags(): void {
    const newTag = new Tag(Navigation.NEW, "", "");
    this.tagsService.select(newTag);
    this.router.navigate([`tags/${Navigation.NEW}`]).then(() => {
      this.tagSelected.emit(Navigation.NEW);
    });
  }
  clearFilter() {
    this.searchTerm.next("");
    this.filteredTags.next(this.tags.value);
  }
}
